module.exports = __webpack_public_path__ + "static/media/x-circle-white.61724fbc.svg";